import React from 'react';
import Layout from 'layouts/member/Layout';
import SampleMessage from 'components/SampleMessage';

const MemberPage: React.FC = () => {
  return (
    <Layout>
      <SampleMessage api_path="welcome" />
      <SampleMessage api_path="login" />
    </Layout>
  );
};

export default MemberPage;